import React from 'react';
import RocketMascot from '../../../../assets/rocket-mascot.png';
import CustomTooltip from '../../../../components/CustomTooltip';
import { CONNECTION_OPTIONS, TOOLTIPS } from '../utilities/constants';

const ConnectionOptions = ({ connectionOption, onOptionChange }) => {
  return (
    <>
      <div className="mascot">
        <img src={RocketMascot} alt="Rocket Mascot" />
      </div>

      <div className="connection-options">
        <h2>Connect WhatsApp Business Platform</h2>
        <p>Select your preferred method for connecting to the WhatsApp Business Platform (API).</p>

        <div className="radio-options">
          <label className="radio-label">
            <input
              type="radio"
              name="connection-type"
              value={CONNECTION_OPTIONS.NEW}
              checked={connectionOption === CONNECTION_OPTIONS.NEW}
              onChange={onOptionChange}
            />
            <span className="custom-radio"></span>
            Set up and connect a NEW WhatsApp Business Platform (API) account{' '}
            <CustomTooltip placement="right" message={TOOLTIPS.NEW_CONNECTION} />
          </label>

          <label className="radio-label">
            <input
              type="radio"
              name="connection-type"
              value={CONNECTION_OPTIONS.EXISTING}
              checked={connectionOption === CONNECTION_OPTIONS.EXISTING}
              onChange={onOptionChange}
            />
            <span className="custom-radio"></span>
            Connect an EXISTING WhatsApp Business Platform (API) account{' '}
            <CustomTooltip
              placement="right"
              message="Select this option if you have created a WhatsApp Business Platform (API) account before."
            />
          </label>
        </div>
      </div>
    </>
  );
};

export default ConnectionOptions;
